export enum NavigationScreenLinkTypes {
    TRACK = "TRACK",
    ORDER_DETAIL = "ORDER_DETAIL",
    CART = "CART",
    CHAT = "CHAT",
    HOME = "HOME",
    MENU = "MENU",
    REFUND_HISTORY = "REFUND_HISTORY",
    COLLECTIONS = "COLLECTIONS",
    IM_TRACK_SCREEN = "IM_TRACK_SCREEN",
    IM_CART = "IM_CART",
}
